export default __webpack_public_path__ + "static/media/Asociaciones.db57dd55.png";